import { render, staticRenderFns } from "./GradeCenter.vue?vue&type=template&id=69460f46&scoped=true&"
import script from "./GradeCenter.vue?vue&type=script&lang=js&"
export * from "./GradeCenter.vue?vue&type=script&lang=js&"
import style0 from "./GradeCenter.vue?vue&type=style&index=0&id=69460f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69460f46",
  null
  
)

export default component.exports